export const noDoubleQuotes = {
  validate(value) {
    if (!value) return true;
    return !value.includes('"');
  },
  message: `{_field_} can't contain double quotes.`,
};
